import { Component } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent {
  constructor(private navigationService: NavigationService) {}

  // True when the user has no landing page at all - e.g. no features or roles are assigned (a misconfigured account),
  // or the license grants none - so this page is their dead end rather than a mistyped URL.
  get hasNoAccess(): boolean {
    return !this.navigationService.getDefaultPageRoute()?.length;
  }

  public async navigateToDefaultPage(): Promise<void> {
    await this.navigationService.navigateToDefaultPage(true);
  }
}
